import { withPluginApi as __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__ } from "discourse/lib/plugin-api";
import { default as __WEBPACK_EXTERNAL_MODULE__components_waze_user_box_896b658e_default__ } from "../components/waze-user-box";
import { default as __WEBPACK_EXTERNAL_MODULE__components_waze_app_launcher_3ac18906_default__ } from "../components/waze-app-launcher";
import { default as __WEBPACK_EXTERNAL_MODULE__components_waze_ai_header_icon_1169534e_default__ } from "../components/waze-ai-header-icon";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "discourse/lib/plugin-api"

;// external "../components/waze-user-box"

;// external "../components/waze-app-launcher"

;// external "../components/waze-ai-header-icon"

;// ./src/plugin/assets/javascripts/discourse/initializers/waze-header-initializer.ts





/* harmony default export */ const waze_header_initializer = ({
    name: "wz-header",
    initialize() {
        __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__("1.34.0", (api) => {
            api.headerIcons.add("waze-ai-header-icon", __WEBPACK_EXTERNAL_MODULE__components_waze_ai_header_icon_1169534e_default__);
            api.headerIcons.add("waze-app-launcher", __WEBPACK_EXTERNAL_MODULE__components_waze_app_launcher_3ac18906_default__);
            api.headerIcons.add("waze-user-box", __WEBPACK_EXTERNAL_MODULE__components_waze_user_box_896b658e_default__);
        });
    },
});

export { waze_header_initializer as default };
